import axios from "axios";

export const deleteTransferApi = async (transferId, lang, cookies) => {
  const token = cookies.__t0ken_amar_management;

  let config = {
    method: "delete",
    url: `${process.env.REACT_APP_API}/transfer/delete/${transferId}`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    timeout: 15000,
  };

  try {
    const res = await axios(config);
    return { success: res.data.success, res: res };
  } catch (error) {
    return { success: false, res: error };
  }
};
